import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MobileService }                       from './mobile.service';
import { MobileStates }                        from './mobile.states';
import { MobileVideoMinutesPurchaseComponent } from './mobile.video-minutes-purchase.component';
import { MobileVideoSettingsComponent }        from './mobile.video-settings.component';
import { SharedModule }                        from '../shared/shared.module';

@NgModule({
  declarations: [
    MobileVideoMinutesPurchaseComponent,
    MobileVideoSettingsComponent
  ],
  entryComponents: [
    MobileVideoMinutesPurchaseComponent,
    MobileVideoSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterModule.forChild({ states: MobileStates })
  ],
  providers: [
    MobileService
  ]
})
export class MobileModule {}
